/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_CardInputs */

const en_guide_json_vs_yaml_xml_card = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare JSON, YAML, and XML. Understand when to use each format and how to convert between them.`)
};

const ko_guide_json_vs_yaml_xml_card = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, YAML, XML을 비교합니다. 각 포맷을 언제 사용하고 어떻게 변환하는지 이해하세요.`)
};

const ja_guide_json_vs_yaml_xml_card = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON、YAML、XMLを比較。各フォーマットの使いどころと変換方法を理解しましょう。`)
};

/**
* | output |
* | --- |
* | "Compare JSON, YAML, and XML. Understand when to use each format and how to convert between them." |
*
* @param {Guide_Json_Vs_Yaml_Xml_CardInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_card = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_CardInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_CardInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_card(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_card(inputs)
	return ja_guide_json_vs_yaml_xml_card(inputs)
});